import React, { useEffect, useState, useRef, useCallback } from "react";
import { MetaTags } from "../../Components/Layout/MetaTags.jsx";
import { Header } from "../../Components/Layout/Header.jsx";
import { ObavijestiCasino } from "../../Components/Layout/ObavijestiCasino.jsx";
import { GameDetails } from "../../Components/Game/GameDetails.jsx";
import { useHistory, useLocation } from "react-router-dom";


export default function ProvidersPage(props) {
    const [height, setHeight] = useState(null);
    const [modal, setModal] = useState("close");
    const [dialogOpen, setDialogOpen] = useState(false);
    const providerRef = useRef(null);
    const providerMainRef = useRef(null);
    const iframeRef = useRef(null);
    const iframeSrc = useRef(`${casino.config.casinoModulesUrl}casino-providers/`);
    const history = useHistory();
    const location = useLocation();
    const providerParam = new URLSearchParams(location.search).get("provider");
    const darkMode = localStorage.getItem("darkModeStrategy") || "light"

    useEffect(() => {
        if (providerParam) {
            providerRef.current = providerParam;
            sendProvider(providerParam);
        } else {
            sendProvider(null)
            window.scrollTo(0, 0);
        }

        window.addEventListener("message", receiveMessages);

        return () => {
            window.removeEventListener("message", receiveMessages);
        }
    }, [providerParam])

    useEffect(() => {
        window.addEventListener("scroll", sendScrollTopOffset);
        return () => {
            window.removeEventListener("scroll", sendScrollTopOffset);
        };
    }, [window.scrollY]);

    useEffect(() => { // provjera je li skriven header, iskljucivo zbog modalnog
        const header = document.getElementById("header");

        if (!header) return;

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === "class") {
                    let headerState = null;

                    if (header.classList.contains("skriveno")) {
                        headerState = "skriveno";
                    } else if (header.classList.contains("plivaj")) {
                        headerState = "plivaj";
                    } 

                    iframeRef.current?.contentWindow.postMessage({
                        type: "header",
                        header: headerState
                    }, "*");
                }
            });
        });

        observer.observe(header, {
            attributes: true,
            attributeFilter: ["class"]
        });

        return () => {
            observer.disconnect();
        };
    }, []);
 
    useEffect(() => {
        if (modal == "open") {
            setTimeout(() => {
                iframeRef.current?.contentWindow.postMessage({
                    type: "deviceHeight",
                    deviceHeight: window.innerHeight,
                }, "*");
            }, 50);
        }

        // handle modal close with back button
        const handlePopState = () => {
            if (modal === "open") {
                if (providerParam) {
                    if (dialogOpen) {
                        setDialogOpen(false)
                        return
                    } else {
                        iframeRef.current?.contentWindow.postMessage({ type: "modal", modal: "close" }, "*");
                        setModal("close")
                        history.push(`/provideri?provider=${providerParam}`);
                    }
                }
            } else if (dialogOpen) {
                history.push(`/provideri?provider=${providerParam}`);
            } else {
                sendProvider(null)
                history.push(`/provideri`)
            };
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [modal, providerParam, history, dialogOpen]);

    useEffect(() => { // check landscape mode for modal 
        const mediaQuery = window.matchMedia("(orientation: landscape)");

        const handleOrientationChange = (e) => {
            const landscape = e.matches;

            // send new device height when orientation changes
            iframeRef.current.contentWindow.postMessage({
                type: "deviceHeight",
                deviceHeight: window.innerHeight,
            }, "*");

            iframeRef.current.contentWindow.postMessage({
                type: "orientation",
                orientation: landscape,
            }, "*");

        };

        mediaQuery.addEventListener("change", handleOrientationChange);

        return () => {
            mediaQuery.removeEventListener("change", handleOrientationChange);
        };
    }, []);

    // Send to child
    const sendScrollTopOffset = () => {
        if (iframeRef.current?.contentWindow) {
            iframeRef.current.contentWindow.postMessage({
                type: "scrollTopOffset",
                scrollTopOffset: window.scrollY
            }, "*");
        } else {
            console.error("iframe is not ready");
        }
    };

    const sendProvider = useCallback((provider) => {
        if (iframeRef.current?.contentWindow) {
            iframeRef.current.contentWindow.postMessage({ type: "provider", provider }, "*");
            iframeRef.current.contentWindow.postMessage({ type: "darkMode", darkMode: casino.utils.getCasinoTheme() === "dark" }, "*");
            iframeRef.current.contentWindow.postMessage({
                type: "deviceHeight",
                deviceHeight: window.innerHeight,
            }, "*");
        } else {
            console.error("iframe is not ready");
        }
    }, []);

    // Receive from child
    const receiveMessages = useCallback(
        (message) => {
            const { data } = message;

            if (data.type === "providersHeight") {
                setHeight(`${data.scrollHeight}px`);
            }

            if (data.type === "dialog") {
                const gameCode = data.params.sifra;
                const game = casino.casinoConstants.games.find((g) => g.s === gameCode);
                const brandName = casino.casinoConstants.brands[game.bID].nameNormalizirano;
                history.push(`/provideri/game/${brandName}/${casino.utils.normalizeString(game.n)}?provider=${providerRef.current}`);
                setDialogOpen(true)
            }

            if (message.data.type === "modalOpen") {
                const modalStatus = message.data.isModalOpen;
                const html = document.getElementsByTagName("html")[0];
                const header = document.getElementById("header");
                setModal(modalStatus ? "open" : "close");

                if (html && header) {
                    html.style.overflow = modalStatus ? "hidden" : "auto";
                    header.style.zIndex = modalStatus && 1;
                    providerMainRef.current.style.position = modalStatus ? "relative" : "initial";
                }

                if (modalStatus && providerParam) {
                    history.push(`/provideri?provider=${providerParam}`);
                }
            }

            if (data.type === "urlParameter") {
                history.push(`/${data.urlParam}`);
            }

            if (data.type == "providersReady") {
                    sendProvider(providerParam);
                    window.scrollTo(0, 0);
            }
        }, [history, providerParam]
    );

    return (
        <>
            <MetaTags
                title="Casino Provideri - SuperSport CASINO"
                description="Pogledaj našu listu vodećih providera online casino igara. Najveća ponuda online casino igara samo u SuperSport casinu. SuperCasino"
            />
            <Header {...props} />
            <main
                id="Casino Providers"
                ref={providerMainRef}
                className={`providers-container${providerParam ? " provider" : ""} ${darkMode}`}
            >
                <iframe
                    className={modal}
                    ref={iframeRef}
                    title="SuperCasino Providers"
                    src={iframeSrc.current}
                    scrolling="no"
                    height={height}
                />
                <div className={"module-modal " + modal} />
            </main>
            <GameDetails
                {...props}
                igre={casino.casinoConstants.games}
                routePrefix={`/provideri?provider=${providerRef.current}`}
            />
            <ObavijestiCasino {...props} />
        </>
    );
}
